// extracted by mini-css-extract-plugin
export default {"main":"Profile_main__61oDl","content":"Profile_content__OyRrW","item":"Profile_item__PWX0h","backIcon":"Profile_backIcon__jZEmE","data":"Profile_data__2ARW9"};